import { render, staticRenderFns } from "./DocDialog.vue?vue&type=template&id=043bebfe&scoped=true"
import script from "./DocDialog.vue?vue&type=script&lang=js"
export * from "./DocDialog.vue?vue&type=script&lang=js"
import style0 from "./DocDialog.vue?vue&type=style&index=0&id=043bebfe&prod&lang=css"
import style1 from "./DocDialog.vue?vue&type=style&index=1&id=043bebfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043bebfe",
  null
  
)

export default component.exports